
import React, { Component } from "react";
import Header from "../Headers/Header";
import Grid from "@material-ui/core/Grid";
import AccordonCommon from "../../CommonScreens/AccordonCommon";
import Loader from "../../loader";
import { createMuiTheme, withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import { FormControl, InputLabel, Select, TextField, Typography } from "@material-ui/core";
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import MenuItem from "@material-ui/core/MenuItem";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import TopBar from './TopPanel/TopBar';
import EmployerSearchBar from './EmployerSearchBar'
import TabView from './TabView/TabView';
import RefreshIcon from "@material-ui/icons/Refresh";
import moment from "moment";
import axios from 'axios';
import configurations from "../../../configurations";
import { buildGetTotalOfMemberByAgentIdUrl, buildEmployerPaymentPayload } from "../../authentication/utils";
import Button from "@material-ui/core/Button";
import styles from "../../../Assets/CSS/stylesheet_UHS";
import Fab from "@material-ui/core/Fab";
import { Modal } from "react-bootstrap";
import Sample from "../../CommonScreens/sampleTextField";
import SampleName from '../../CommonScreens/sampleTextFieldName';
import CommonDropDwn from "../../CommonScreens/CommonDropDwn_1.js";
import { getMuiTheme } from '../../CommonScreens/AgentTable';
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import Footer from "../../CommonScreens/Footer";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from "@material-ui/core/Tooltip";
import MuiPhoneNumber from "material-ui-phone-number";
import ShimmerDashboard from "../../../Assets/Loaders/ShimmerEffect.jsx";
import Commission from "./Commission/index.jsx";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';
import { getTokenForAuthentication } from "../../authentication/utils.js";
import Dashboard from "../../CommonScreens/Dashboard.js";
import { de } from "date-fns/locale";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

var convert = require('xml-js');

var formData = new FormData();
formData.append("draw", "1");
formData.append("start", "0");
formData.append("length", "10");
formData.append("columns[0].data", "id");
formData.append("columns[0].name", "");
formData.append("columns[0].searchable", "true");
formData.append("columns[0].orderable", "true");
formData.append("columns[0].search.regex", "false");
formData.append("columns[0].search.value", "");

formData.append("columns[1].data", "createdDate");
formData.append("columns[1].name", "");
formData.append("columns[1].searchable", "true");
formData.append("columns[1].orderable", "true");
formData.append("columns[1].search.regex", "false");
formData.append("columns[1].search.value", "");

formData.append("columns[2].data", "email");
formData.append("columns[2].name", "");
formData.append("columns[2].searchable", "true");
formData.append("columns[2].orderable", "true");
formData.append("columns[2].search.regex", "false");
formData.append("columns[2].search.value", "");

formData.append("columns[3].data", "companyName");
formData.append("columns[3].name", "");
formData.append("columns[3].searchable", "true");
formData.append("columns[3].orderable", "true");
formData.append("columns[3].search.regex", "false");
formData.append("columns[3].search.value", "");


formData.append("order[0].column", "0");
formData.append("order[0].dir", "desc");
formData.append("search.regex", "false");
formData.append("search.value", "");

let requestOptions = {
    method: 'POST',
    body: formData,
};

const CustomButton = withStyles(
    customStyle.viewBtn
)(Button);
const CrudButton = withStyles(
    styles.crudBtnAgent,
)(Fab);

const NextButton = withStyles(
    customStyle.doneBtn
)(Button);

const CssTextField = withStyles(theme => ({
    root: {
        '& .MuiInput-root': {
            "&:hover:not($disabled):not($focused):not($error):before": {
                borderBottom: '2px solid #2f3192'
            },

            '&.MuiInput-underline.Mui-focused:after': {
                borderBottom: '2px solid #2f3192',
            },

        }
    },
}))(TextField);

const PurpleRadio = withStyles(customStyle.radioBtn)((props) => (
    <Radio color="default" {...props} />
));

// Employer effective dates are restricted to the 1st or the 15th of any month,
// within the next 90 days. Returns the next eligible date strictly after today.
const getNextEmployerEffectiveDate = (fromDate) => {
    const base = fromDate ? new Date(fromDate) : new Date();
    const result = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    const day = result.getDate();
    if (day < 15) {
        result.setDate(15);
    } else {
        result.setMonth(result.getMonth() + 1);
        result.setDate(1);
    }
    return result;
};

// Maximum selectable effective date: 90 days from today.
const getEmployerEffectiveMaxDate = (fromDate) => {
    const base = fromDate ? new Date(fromDate) : new Date();
    const result = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    result.setDate(result.getDate() + 90);
    return result;
};

// Helper to get the next 1st or 15th after a given date (+45 days from today)
const getNextAllowedEffectiveDate = (fromDate) => {
    const base = fromDate ? new Date(fromDate) : new Date();
    base.setHours(0, 0, 0, 0);
    let result = new Date(base);
    let day = result.getDate();
    if (day < 15) {
        result.setDate(15);
    } else {
        result.setMonth(result.getMonth() + 1);
        result.setDate(1);
    }
    return result;
};

// Only allow 1st or 15th, and only after minDate
const isAllowedEffectiveDate = (date, minDate) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const min = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
    const day = d.getDate();
    return (day === 1 || day === 15) && d >= min;
};

class Employer extends Component {

    constructor(props) {
        super(props);

        let USER_DATA = JSON.parse(sessionStorage.getItem('USER_DATA'));
        this.state = {
            ...this.state,
            lastRefreshAt: null,
        }

        this.state = {
            employerList: [],
            count: 0,
            USER_DATA: USER_DATA,
            loaderShow: false,
            targetDate: null,
            rowIndex: 0,
            addEmployerModal: false,
            compName: '',
            zipCode: '',
            state: '',
            city: '',
            street: '',
            division: '',
            industry: '',
            topbarData:null,
            codeTitle: '',
            code: '',
            firstName: '',
            lastName: '',
            workEmail: '',
            jobTitle: '',
            phone: '',
            divisionList: [],
            industryList: [],
            codeTitleList: [],
            codeList: [],
            countryCode: '',
            searchTextInput:"",
            msgModal: false,
            errMsg: '',
            employerDetailsObj: [],
            disableSubmit: true,
            employerEdit: false,
            searchTypeValue: '',
            searchShow: false,
            searchText: '',
            rowsPerPage: 10,
            effectiveDate: this.getNextEffectiveday() || null,
            dateErr: false,
            birthDtFocus: false,
            birthDt: false,
            adminPhone: '',
            adminFirstName: '',
            adminLastName: '',
            adminEmail: '',
            adminCountryCode: '',
            empid: '',
            page: 0,
            copyEmpCheck: false,
            isMaximized: false,
            payrollCycle: 'Weekly',
            employerContribution: '',
            contributionType: 'Doller',
            accountTypes: [],
            bankName: '',
            accountName: '',
            routingNo: '',
            accountNumber: '',
            accountType: '',
            defaultCountryCode: '+1'
        }
    }

    toggleMaximize = () => {
        this.setState(prevState => ({ isMaximized: !prevState.isMaximized }));
    };
    getNextEffectiveday = () => {
          const today = new Date();
        const minAllowedDate = new Date(today);
        minAllowedDate.setDate(minAllowedDate.getDate() + 45);
        const nextAllowed = getNextAllowedEffectiveDate(minAllowedDate);
        return new Date(nextAllowed)
    }

    componentDidMount() {
        this.setState({
            loaderShow: true
        });
        this.getEmployerData();
        this.getTopBarData();
        let obj = {
            "searchKey": "division",
            "searchValue": ""
        }
        axios.post(process.env.REACT_APP_BASE_URL + '/employer/getSIC', obj)
            .then(response => {
                let divisionList = [];
                for (let i = 0; i < response.data.response.length; i++) {
                    divisionList.push({
                        key: response.data.response[i].division,
                        value: response.data.response[i].division
                    });

                }
                this.setState({
                    divisionList: divisionList
                })
            })

        fetch(process.env.REACT_APP_enrollment_base_url + "/setuppayment/getAccountType")
            .then((response) => response.json())
            .then((response) => {
                const accountTypes = (response.response || []).map((item) => {
                    if (typeof item === 'string') {
                        return { key: item, value: item };
                    }
                    const label = item.key || item.value || item.name || item.accountType || '';
                    const value = item.value || item.key || item.name || item.accountType || '';
                    return { key: label, value: value };
                });
                this.setState({
                    accountTypes: accountTypes,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }
    getTopBarData = () => {
        this.setState({ loaderCommission: true });
        let ud = {};
        try {
            const raw = sessionStorage.getItem("USER_DATA");
            if (raw) {
                ud = JSON.parse(raw);
            }
        } catch (e) {
            this.setState({ loaderCommission: false });
            return;
        }
        const totalMembersUrl = buildGetTotalOfMemberByAgentIdUrl(ud.agentId, "");
        if (!totalMembersUrl) {
            this.setState({ loaderCommission: false });
            return;
        }
        axios
            .get(totalMembersUrl)
            .then((response) => {
                this.setState({
                    topbarData: response.data.response,
                    lastRefreshAt: new Date(),
                    loaderCommission: false,
                });
            })
            .catch(() => {
                this.setState({ loaderCommission: false });
            });
    }
        // Handler to log tab name when clicked
    handleTabClick = (tabName) => {
        console.log("Tab clicked:", tabName);
        if (tabName === 0) {
            // Dashboard tab: refresh both employer data and top bar
            this.getEmployerData();
            this.getTopBarData();
        } else if (tabName === 1) {
            // Active Employers tab: refresh employer data
            this.getEmployerData();
        }
        // No API call needed for SERVICE FEE tab (index 2)
        // Optionally, update state if you want to track the active tab
        // this.setState({ activeTab: tabName });
    }

    getEmployerData = () => {
        fetch(process.env.REACT_APP_BASE_URL + '/employer/getEmployerByBrokerId/' + this.state.USER_DATA.agentId, requestOptions)
            .then(response => response.json())
            .then(response => {
                if (response.response && response.response.data) {
                    this.setState({
                        employerList: response.response.data,
                        count: response.response.recordsFiltered,
                        loaderShow: false
                    })
                } else {
                    this.setState({ loaderShow: false })
                }
            }).catch((err) => {

            })
    }

    changePage = (page, rows) => {
        this.setState({
            loaderShow: true
        });
        if (page !== undefined && rows) {
            let nextPage = (page * rows)
            formData.set("start", nextPage.toString());
            formData.set("length", rows.toString());
            fetch(process.env.REACT_APP_BASE_URL + '/employer/getEmployerByBrokerId/' + this.state.USER_DATA.agentId, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ employerList: data.response.data, rowsPerPage: rows, loaderShow: false, page: page })
                    } else {
                        this.setState({ loaderShow: false })
                    }
                });
        }
    }
    /* ========================== server side sorting logic================= */
    sort = (changedColumn, order) => {

        formData.set("start", "0");
        formData.set("order[0].column", changedColumn);
        formData.set("order[0].dir", order);
        fetch(configurations.baseUrl + '/employer/getEmployerByBrokerId/' + this.state.USER_DATA.agentId, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.response && data.response.data) {
                    this.setState({ employerList: data.response.data, count: data.response.recordsFiltered, loaderShow: false })
                } else {
                    this.setState({ loaderShow: false })
                }
            });
    }

     getGeoInfo = () => {
        
    };

    addEmployerModal = () => {
        this.setState({
            loaderShow: true
        });

        if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
            this.setState({
                countryCode: "+91",
                adminCountryCode: "+91"
            });
        }else
        this.setState({
            countryCode: "+1",
            adminCountryCode: "+1"
        });
      
        const today = new Date();
        const tomorrow = getNextEmployerEffectiveDate(today);

        this.setState({

            addEmployerModal: true,
            loaderShow: false,
            errMsg: '',
            compName: '',
            zipCode: '',
            state: '',
            city: '',
            street: '',
            division: '',
            industry: '',
            codeTitle: '',
            code: '',
            firstName: '',
            lastName: '',
            workEmail: '',
            jobTitle: '',
            phone: '',
            industryList: [],
            codeTitleList: [],
            codeList: [],
            adminPhone: '',
            adminFirstName: '',
            adminLastName: '',
            adminEmail: '',
            empid: '',
            effectiveDate: this.getNextEffectiveday() || null,
            payrollCycle: 'Weekly',
            employerContribution: '',
            contributionType: 'Doller',
            bankName: '',
            accountName: '',
            routingNo: '',
            accountNumber: '',
            accountType: '',
        });
        /*let obj = {
            "searchKey":"division",
            "searchValue": ""
        }
        axios.post(process.env.REACT_APP_BASE_URL + '/employer/getSIC', obj )
            .then(response => {
                let divisionList =[];
                for(let i=0; i<response.data.response.length; i++){
                    divisionList.push({key : response.data.response[i].division, value : response.data.response[i].division});
                }


            });*/
    }

    addEmployer = () => {
        this.setState({
            loaderShow: true
        })
        let URL = process.env.REACT_APP_BASE_URL + '/employer/addEmployer';
        let newPhone = this.state.phone ?  this.state.phone.replace(/[^a-zA-Z0-9]/g, '') : '';
        let newAdminPhone = this.state.adminPhone ?  this.state.adminPhone.replace(/[^a-zA-Z0-9]/g, '') : "";

        let obj = {
            "clientId": this.state.USER_DATA.clientId ? this.state.USER_DATA.clientId.toString() : '',
            "companyName": this.state.compName.trim(),
            "firstName": this.state.firstName.trim(),
            "lastName": this.state.lastName.trim(),
            "jobTitle": this.state.jobTitle.trim(),
            "phone":this.state.phone?this.state.countryCode + newPhone.substr(1):'',
            "zip": this.state.zipCode,
            "state": this.state.state,
            "city": this.state.city,
            "street": this.state.street,
            "effective_date": moment(this.state.effectiveDate).format('YYYY-MM-DD'),
            "brokerId": this.state.USER_DATA.agentId,
            "division": this.state.division,
            "industry": this.state.industry,
            "codeTitle": this.state.codeTitle,
            "code": this.state.code,
            adminFirstName: this.state.adminFirstName.trim(),
            adminLastName: this.state.adminLastName.trim(),
            adminPhone: this.state.adminPhone?this.state.adminCountryCode + newAdminPhone.substr(1):'',
            adminEmail: this.state.adminEmail,
            email: this.state.workEmail.toLowerCase(),
            payrollCycle: this.state.payrollCycle,
            contributionType: this.state.contributionType,
            employerContribution: this.state.employerContribution !== '' && this.state.employerContribution != null
                ? Number(this.state.employerContribution)
                : 0,
            employerPayment: buildEmployerPaymentPayload({
                bankName: this.state.bankName,
                accountName: this.state.accountName,
                accountNumber: this.state.accountNumber,
                accountType: this.state.accountType,
                routingNo: this.state.routingNo,
            }),
            "time": new Date().getTime(),
            "timeZone": Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        if (this.state.employerEdit) {
            URL = process.env.REACT_APP_BASE_URL + '/employer/updateEmployer';
            obj.empid = this.state.empid
        }

        axios.post(URL, obj)
            .then(response => {
                let errMsg = '';
                if (response.data.code === 200) {
                    errMsg = this.state.employerEdit ? 'Employer Updated Successfully !' : 'Employer Added Successfully !'
                } else {
                    errMsg = response.data.message
                }
                let today = new Date();
                let tomorrow = getNextEmployerEffectiveDate(today);

                this.setState({
                    msgModal: true,
                    addEmployerModal: false,
                    errMsg: errMsg,
                    compName: '',
                    zipCode: '',
                    state: '',
                    city: '',
                    street: '',
                    division: '',
                    industry: '',
                    codeTitle: '',
                    code: '',
                    firstName: '',
                    lastName: '',
                    workEmail: '',
                    jobTitle: '',
                    phone: '',
                    industryList: [],
                    codeTitleList: [],
                    codeList: [],
                    countryCode: '',
                    employerEdit: false,
                    adminPhone: '',
                    adminFirstName: '',
                    adminLastName: '',
                    adminEmail: '',
                    adminCountryCode: '',
                    effectiveDate: new Date(tomorrow),
                    empid: '',
                    copyEmpCheck: false,
                    isMaximized: false,
                    payrollCycle: 'Weekly',
                    employerContribution: '',
                    contributionType: 'Doller',
                    bankName: '',
                    accountName: '',
                    routingNo: '',
                    accountNumber: '',
                    accountType: '',
                });
                this.getEmployerData();
            })

    }

    checkEnable = () => {
        const { compName, zipCode, state, city, street, division, industry, codeTitle, code, firstName, lastName, workEmail, jobTitle, phone, adminPhone, adminFirstName, adminLastName, adminEmail } = this.state;
        if (compName !== '' && zipCode !== '' && state !== '' && city !== '' && firstName !== '' && lastName !== '' && workEmail !== ''  && adminFirstName !== '' && adminLastName !== '' && adminEmail !== '') {
            this.setState({
                disableSubmit: false
            })
        } else {
            this.setState({
                disableSubmit: true
            })
        }
    }

    copyEmployerDetails = () => {
        console.log("==Clicked===");
        console.log(this.state.copyEmpCheck);
        if (this.state.copyEmpCheck == false) {
            this.setState({ 
                copyEmpCheck: true,
                adminFirstName: this.state.firstName,
                adminLastName: this.state.lastName,
                adminEmail: this.state.workEmail,
                adminPhone: this.state.phone,
            }, () => this.checkEnable())
            
        } else {
            this.setState({ 
                copyEmpCheck: false,
                adminFirstName: '',
                adminLastName: '',
                adminEmail: '',
                adminPhone: '',
            }, () => this.checkEnable())

        }

    }

    closeEmployerModal = () => {
        let today = new Date();
        let tomorrow = getNextEmployerEffectiveDate(today);
        this.setState({
            addEmployerModal: false,
            errMsg: '',
            // compName: '',
            // zipCode: '',
            // state: '',
            // city: '',
            // street: '',
            // division: '',
            // industry: '',
            // codeTitle: '',
            // code: '',
            // firstName: '',
            // lastName: '',
            // workEmail: '',
            // jobTitle: '',
            // phone: '',
            // industryList: [],
            // codeTitleList: [],
            // codeList: [],
            // countryCode: '',
            // adminPhone: '',
            // adminFirstName: '',
            // adminLastName: '',
            // adminEmail: '',
            // adminCountryCode: '',
            // effectiveDate: new Date(tomorrow),
            employerEdit: false,
            isMaximized: false,
            // empid: '',
            // copyEmpCheck: false
        }, () => this.checkEnable())
    }

    setEmpValue = (value, isValid, parentDetails) => {

        if (isValid) {
            if (parentDetails.name === 'workEmail' || parentDetails.name === 'adminEmail' || parentDetails.name === 'compName' || parentDetails.name === 'employerContribution' || parentDetails.name === 'bankName' || parentDetails.name === 'accountName' || parentDetails.name === 'routingNo' || parentDetails.name === 'accountNumber' || parentDetails.name === 'accountType') {
                this.state[parentDetails.name] = value;
            } else {
                this.state[parentDetails.name] = value.toUpperCase();
            }
            if (parentDetails.name === 'zipCode') {
                this.handleZipCode(value, parentDetails);
            }
        } else {
            this.state[parentDetails.name] = "";
        }
        this.setState({
            refresh: true
        }, () => { this.checkEnable() });
    }

    handleZipCode = (zipcode, parent) => {
        this.setState({
            loaderShow: true
        });
        let url = `${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/zipcode/lookup?zipcode=${zipcode}`
        axios.get(url)
            .then(response => {
                var result2 = response.data;
                if (!result2.stateAbbreviation) {
                    var evt = new CustomEvent('zip', { detail: { zipcode: zipcode, flag: true, errMsg: "Enter valid zip code", parentDetails: parent } });
                    window.dispatchEvent(evt);
                    this.state.city = '';
                    this.state.state = '';
                    this.state.country = '';
                    this.setState({
                        refresh: true,
                        loaderShow: false
                    }, () => { this.checkEnable() });

                } else {
                    getTokenForAuthentication().then((response) => {
                    let token = response['headers'].authorization;
                    axios
                        .get(`${process.env.REACT_APP_AGENCY_URL}check-state-sellable?agencyId=${this.state.USER_DATA.clientId}&stateCode=${result2.stateAbbreviation}`, {
                        headers: {
                            Authorization: token
                        }
                        })
                        .then(response => {
                            this.setState({
                                loaderShow: false
                            });

                            if (!response.data.response) {
                                this.state.zipCode = zipcode;
                                this.state.state = result2.stateAbbreviation;
                                this.state.city = result2.city;
                                this.state.country = 'US';
                                this.setState({
                                    refresh: true,
                                    loaderShow: false
                                }, () => { this.checkEnable() });
                            } else {
                                this.state.state = '';
                                this.state.city = '';
                                this.state.country = '';
                                var evt = new CustomEvent('zip', { detail: { zipcode: zipcode, flag: true, errMsg: 'We’re sorry. At this time, we are not offering the Universal HealthShare program in this zip code', parentDetails: parent } });
                                window.dispatchEvent(evt);
                                this.setState({
                                    refresh: true,
                                    loaderShow: false
                                }, () => { this.checkEnable() });
                            }
                        });
                        });
                }
            })
            .catch(error => {
                var evt = new CustomEvent('zip', { detail: { zipcode: zipcode, flag: true, errMsg: "An unexpected error occurred. Please try again later.", parentDetails: parent } });
                window.dispatchEvent(evt);
                this.state.city = '';
                this.state.state = '';
                this.state.country = '';
                this.setState({
                    refresh: true,
                    loaderShow: false
                }, () => { this.checkEnable() });
            })
    };

    setEmpDropDownValue = (value, isValid, parentDetails) => {
        this.setState({
            loaderShow: true
        })
        if (isValid) {
            this.state[parentDetails.name] = value;
        } else {
            this.state[parentDetails.name] = "";
        }

        if (parentDetails.name === 'division') {
            this.setState({
                industryList: [],
                codeTitleList: [],
                code: ''
            })
            let obj = {
                "searchKey": "industry",
                "searchValue": value
            }

            this.getSICDetails(obj);
        } else if (parentDetails.name === 'industry') {
            this.setState({
                codeTitleList: [],
                code: ''
            })
            let obj = {
                searchKey: 'codeTitle',
                searchValue: value
            }
            this.getSICDetails(obj);
        } else if (parentDetails.name === 'codeTitle') {
            let findIndex = this.state.codeTitleList.find(obj => obj.key === value);
            if (findIndex) {
                //this.state.code = findIndex.sicCode;
                this.setState({
                    code: findIndex.sicCode,
                    loaderShow: false
                });
            }
        }
        this.setState({
            refresh: true,
        }, () => { this.checkEnable() });
    }

    getSICDetails = (obj) => {
        axios.post(process.env.REACT_APP_BASE_URL + '/employer/getSIC', obj)
            .then(response => {
                let arr = [];
                let data = response.data.response;
                if (obj.searchKey === 'industry') {
                    for (let i = 0; i < data.length; i++) {
                        arr.push({ key: data[i].industry, value: data[i].industry })
                    }
                    this.setState({
                        industryList: arr,
                        loaderShow: false
                    }, () => { this.checkEnable() })
                } else if (obj.searchKey === 'codeTitle') {
                    for (let i = 0; i < data.length; i++) {
                        arr.push({ key: data[i].codeTitle, value: data[i].codeTitle, sicCode: data[i].sicCode })
                    }
                    this.setState({
                        codeTitleList: arr,
                        loaderShow: false
                    }, () => { this.checkEnable() })
                }
            });
    }

    menuOptions = [
        "Open",
        "View Employer",
        "Edit Employer",
        "View Auth PDF"
    ];

    columns = [
        // { label: "User Id", name: "id" },
        {
            label: "Date Added", name: "createdDate", options: {
                sort: true,
                customBodyRenderLite: (index) => {
                    // this.state.dateAdded= (this.state.data[index].createdDate).format('yy-mm-dd');
                    if (this.state.employerList && this.state.employerList[index] && this.state.employerList[index].createdDate) {
                        return moment(this.state.employerList[index].createdDate).format('MMMM DD, YYYY');
                    } else {
                        return "NA";
                    }
                }
            }
        },
        {
            label: "Company Name", name: "companyName", options: {
                sort: true,
                customBodyRenderLite: (index) => {
                    if (this.state.employerList && this.state.employerList[index] && this.state.employerList[index].companyName) {
                        return this.state.employerList[index].companyName;
                    } else {
                        return 'NA';
                    }
                }
            }
        },
        {
            label: "Email ", name: "email", options: {
                sort: true,
            }
        },
        {
            name: "Action", options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <span >
                            <PopupState variant="popover" popupId="demo-popup-menu" >
                                {(popupState) => (
                                    <React.Fragment>
                                        <IconButton {...bindTrigger(popupState)}>
                                            <MoreVertIcon style={{color: "#2f3192"}}  />
                                        </IconButton>
                                        <Menu {...bindMenu(popupState)} onClick={popupState.close}
                                            getContentAnchorEl={null}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center'
                                            }}
                                            transformOrigin={{
                                                vertical: -10,
                                                horizontal: 30
                                            }}
                                        >
                                            {
                                                this.state.employerList && this.state.employerList[dataIndex] &&
                                                <div>
                                                    {
                                                        this.menuOptions.map((option, index) => {
                                                            // "View Auth PDF" is only available after the employer
                                                            // has completed acknowledgement.
                                                            if (option === "View Auth PDF" && !this.state.employerList[dataIndex].acknowledgement) {
                                                                return null;
                                                            }
                                                            return <MenuItem key={index} value='view' onClick={(e) => this.selectOption(index, dataIndex)}  >{option}</MenuItem>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </Menu>
                                    </React.Fragment>
                                )}
                            </PopupState>

                        </span>
                    );
                }
            }
        }
    ];

    selectOption = (index, dataIndex) => {
        if (index === 0) {  //open employee
            console.log(window.location);
            axios.get(process.env.REACT_APP_BASE_URL + '/employer/getEmployerByEmpId/' + this.state.employerList[dataIndex].empid)
                .then(response => {
                    console.log(response);
                    if (response.data.response) {
                        if (response.data.response.acknowledgement) {
                            window.location.replace(window.location.origin + '/manage-prospects?empid=' + this.state.employerList[dataIndex].empid + '&tab=prospects')
                        } else {
                            this.setState({
                                acknowledgement: response.data.response.acknowledgement,
                                showAcknowledgementModal: true,
                                sendAuthEmail: this.state.employerList[dataIndex].email
                            })
                        }
                    }
                })
        }
        if (index === 1) {
            let obj = [
                {
                    key: 'Company Name',
                    value: this.state.employerList[dataIndex].companyName
                },
                {
                    key: 'Name',
                    value: this.state.employerList[dataIndex].firstName + ' ' + this.state.employerList[dataIndex].lastName
                },
                {
                    key: 'Email id',
                    value: this.state.employerList[dataIndex].email
                },
                {
                    key: 'Phone Number',
                    value: this.state.employerList[dataIndex].phone?this.state.employerList[dataIndex].phone:'NA'
                },
                {
                    key: 'Zip Code',
                    value: this.state.employerList[dataIndex].zip
                },
                {
                    key: 'State',
                    value: this.state.employerList[dataIndex].state
                },
                {
                    key: 'Street, Suit',
                    value: this.state.employerList[dataIndex].street
                },
                {
                    key: 'Division',
                    value: this.state.employerList[dataIndex].division
                },
                {
                    key: 'Industry',
                    value: this.state.employerList[dataIndex].industry
                },
                {
                    key: 'SIC Code Title',
                    value: this.state.employerList[dataIndex].codeTitle
                },
                {
                    key: 'SIC Code',
                    value: this.state.employerList[dataIndex].code
                },
                {
                    key: "Effective Date",
                    value: this.state.employerList[dataIndex].effective_date ? moment(this.state.employerList[dataIndex].effective_date).format('MMMM DD, YYYY') : null
                },
                {
                    key: 'Administrator Name',
                    value: this.state.employerList[dataIndex].adminFirstName ? this.state.employerList[dataIndex].adminFirstName + ' ' + this.state.employerList[dataIndex].adminLastName : 'NA'
                },
                {
                    key: 'Administrator Email Id',
                    value: this.state.employerList[dataIndex].adminEmail ? this.state.employerList[dataIndex].adminEmail : 'NA'
                },
                {
                    key: 'Administrator Phone Number',
                    value: this.state.employerList[dataIndex].adminPhone ? this.state.employerList[dataIndex].adminPhone : 'NA'
                }
            ]



            this.setState({
                employerDetailsObj: obj,
                viewEmployerModal: true
            })
        } 
        if (index === 2) {
            const { companyName, zip, state, city, street, division, industry, codeTitle, code, firstName, lastName, email, jobTitle, phone, effective_date, adminPhone, adminFirstName, adminLastName, adminEmail, empid, payrollCycle, contributionType, employerContribution, employerPayment, acknowledgement } = this.state.employerList[dataIndex];
            const achPayment = employerPayment || {};
            let obj = {
                "searchKey": "industry",
                "searchValue": division
            }
            this.getSICDetails(obj);
            let newObj = {
                "searchKey": "codeTitle",
                "searchValue": industry
            }
            this.getSICDetails(newObj);
            let phoneNumber = '';
            let countryCode = '';

            if (phone && phone.length>0){
                if (phone.length === 13) {
                    countryCode = phone.substr(0, 3);
                    phoneNumber = this.formatPhoneNumber(phone.substr(2));
                    // phoneNumber = phone.substr(3);
                } else {
                    countryCode = phone.substr(0, 2);
                    phoneNumber = this.formatPhoneNumber(phone);
                }
            }else{

                if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
                        this.setState({
                            countryCode: "+91",
                             phoneNumber: phone
                        });
                    }else
                    this.setState({
                        countryCode: "+1",
                         phoneNumber: phone
                    });

               
            }


            let adminPhoneNumber = '';
            let adminCountryCode = '';
            if (adminPhone) {
                if (adminPhone.length === 13) {
                    adminCountryCode = adminPhone.substr(0, 3);
                    adminPhoneNumber = this.formatPhoneNumber(adminPhone.substr(2));
                    // adminPhoneNumber = adminPhone.substr(3);
                } else {
                    adminCountryCode = adminPhone.substr(0, 2);
                    adminPhoneNumber = this.formatPhoneNumber(adminPhone);
                    // adminPhoneNumber = adminPhone.substr(2);
                }
                this.setState({
                    compName: companyName,
                    zipCode: zip,
                    state: state,
                    city: city,
                    street: street,
                    division: division,
                    industry: industry,
                    codeTitle: codeTitle,
                    code: code,
                    firstName: firstName,
                    lastName: lastName,
                    workEmail: email,
                    jobTitle: jobTitle,
                    phone: phoneNumber,
                    countryCode: countryCode,
                    effectiveDate: effective_date ? new Date(effective_date) : effective_date,
                    employerEdit: true,
                    addEmployerModal: true,
                    adminPhone: adminPhoneNumber,
                    adminFirstName: adminFirstName,
                    adminLastName: adminLastName,
                    adminEmail: adminEmail,
                    adminCountryCode: adminCountryCode,
                    empid: empid,
                    payrollCycle: payrollCycle || 'Weekly',
                    contributionType: contributionType || 'Doller',
                    employerContribution: employerContribution != null && employerContribution !== '' ? String(employerContribution) : '',
                    bankName: achPayment.bankName || '',
                    accountName: achPayment.accountName || '',
                    routingNo: achPayment.routingNo || '',
                    accountNumber: achPayment.accountNumber || '',
                    accountType: achPayment.accountType || '',
                    acknowledgement: acknowledgement || '',
                })
            } else {

                let countryCode = '+1';
                if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
                    countryCode = "+91";
                }
                
            
                
                
                    
                        
                        this.setState({
                            compName: companyName,
                            zipCode: zip,
                            state: state,
                            city: city,
                            street: street,
                            division: division,
                            industry: industry,
                            codeTitle: codeTitle,
                            code: code,
                            firstName: firstName,
                            lastName: lastName,
                            workEmail: email,
                            jobTitle: jobTitle,
                            phone: phoneNumber,
                            countryCode: countryCode,
                            effectiveDate: effective_date ? new Date(effective_date) : effective_date,
                            employerEdit: true,
                            addEmployerModal: true,
                            adminPhone: adminPhoneNumber,
                            adminFirstName: adminFirstName,
                            adminLastName: adminLastName,
                            adminEmail: adminEmail,
                            adminCountryCode: countryCode,
                            empid: empid,
                            payrollCycle: payrollCycle || 'Weekly',
                            contributionType: contributionType || 'Doller',
                            employerContribution: employerContribution != null && employerContribution !== '' ? String(employerContribution) : '',
                            bankName: achPayment.bankName || '',
                            accountName: achPayment.accountName || '',
                            routingNo: achPayment.routingNo || '',
                            accountNumber: achPayment.accountNumber || '',
                            accountType: achPayment.accountType || '',
                        })
                    
            
            }
        }
        if (index === 3) {
            window.open(configurations.baseUrl + `/employer/eSignPdf/${this.state.employerList[dataIndex].email}`, "_blank");
        }
    }
    formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
      }
    handleChangeSearchType(event) {
        let value = event.target.value;

        if (value === '' || value === null) {
            this.setState({ searchShow: true, searchText: '', page: 0 }, () => {
                this.searchRecord();
            });
        } else {
            if (this.state.searchTypeValue === '0') {
                formData.set("columns[1].search.value", "");
            } else if (this.state.searchTypeValue === '1') {
                formData.set("columns[3].search.value", "");
            }
            this.setState({ searchTypeValue: value, searchShow: false, searchText: '', page: 0 }, () => {
                this.searchRecord();
            });
        }
    }


    searchRecord = (val) => {
        this.setState({
            loaderShow: true
        });
        let value = "";
        if(val){
            value = val;
        }
        this.setState({searchTextInput : val})

        if (this.state.searchTypeValue === '0') { //Date search
            formData.set("start", "0");
            formData.set("columns[1].search.value", this.state.searchText);

            fetch(configurations.baseUrl + '/employer/getEmployerByBrokerId/' + this.state.USER_DATA.agentId, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ employerList: data.response.data, count: data.response.recordsFiltered, statusValue: '', loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                });
        } else if (this.state.searchTypeValue === '1') { //Company name search
            formData.set("start", "0");
            formData.set("length", this.state.rowsPerPage.toString());
            formData.set("columns[3].search.value", value);

            fetch(configurations.baseUrl + '/employer/getEmployerByBrokerId/' + this.state.USER_DATA.agentId, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ employerList: data.response.data, count: data.response.recordsFiltered, targetDate: null, statusValue: '', loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                });
        }
    }

    handleDate(event) {
        this.setState({
            targetDate: moment(event).format('YYYY') + '-' + moment(event).format('MM') + '-' + moment(event).format('DD'),
            searchText: moment(event).format('YYYY') + '-' + moment(event).format('MM') + '-' + moment(event).format('DD'),
        }, () => {
            if(this.state.searchText !== '' && this.state.targetDate !== '') {
                 this.searchRecord()
            }
        });
    }

    refreshEmployer = () => {
        this.setState({
            loaderShow: true,
            searchTypeValue:"",
            searchText:"",
            targetDate: null,
            loaderCommission:true
        });
        formData.set("start", "0");
        formData.set("length", this.state.rowsPerPage.toString());
        formData.set("columns[3].search.value", "");
        formData.set("columns[1].search.value", "");
        this.getEmployerData();
    }

    handleDateChange = (date, didMount) => {
        this.setState({
            effectiveDate: date
        }
            , () => {
                let panel = document.getElementById("date-picker-dialog");
                panel.addEventListener("onmouseleave", function () {
                    document.getElementById("date-picker-dialog-label").style.paddingTop = "10px";
                });
            }
        );
    }

    disableWeekends(date, clientId) {
        // Employer effective date must be either the 1st or the 15th of any month.
        const day = date.getDate();
        return !(day === 1 || day === 15);
    }

    sendAuth = () => {
        this.setState({
            loaderShow: true,
        })
        axios.get(configurations.baseUrl + `/employer/employerRegistration/${this.state.sendAuthEmail}`)
            .then(response => {
                console.log('empres', response);
                if (response.data.code === 200) {
                    this.setState({
                        loaderShow: false,
                        showAcknowledgementModal: false,
                        authSent: true,
                        msgModal: true,
                        errMsg: 'Auth Email Sent!'
                    })
                } else {
                    this.setState({
                        loaderShow: false,
                        showAcknowledgementModal: false,
                        msgModal: true,
                        errMsg: (response.data && response.data.message) || 'Unable to send auth email. Please try again.'
                    })
                }
            })
            .catch((err) => {
                console.error('sendAuth', err);
                this.setState({
                    loaderShow: false,
                    showAcknowledgementModal: false,
                    msgModal: true,
                    errMsg: 'Unable to send auth email. Please try again.'
                })
            })
    }

    render() {

        const options = {
            selectableRows: false,
            filter: false,
            selectableRowsHeader: false,
            count: this.state.count,
            rowsPerPage: this.state.rowsPerPage,
            tableBodyHeight: 'calc(-319px + 100vh)',
            search: false,
            serverSide: true,
            download: false,
            viewColumns: false,
            print: false,
            fixedHeader: true,
            page: this.state.page,
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.changePage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.changePage(tableState.page, tableState.rowsPerPage);
                        break;
                    default:
                        break;
                }
            },
            onColumnSortChange: (changedColumn, direction) => {
                // this.setState({
                //     loaderShow: true
                // });
                let order = 'desc';
                if (direction === 'asc') {
                    order = 'asc';
                }
                let columnIndex = '0';
                if (changedColumn === "createdDate") {
                    columnIndex = '1';
                } else if (changedColumn === 'email') {
                    columnIndex = '2';
                } else if (changedColumn === 'firstName') {
                    columnIndex = '4';
                }
                this.sort(columnIndex, order);
            },
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.state.rowIndex = rowsSelected;
            },
            onCellClick: (cellIndex, rowIndex, rowMeta) => {
                console.log('cellIndex======', cellIndex);
                console.log('rowIndex======', rowIndex.colIndex);

                if (rowIndex.colIndex && rowIndex.colIndex !== 3) {

                    this.setState({
                        // loaderShow: true
                    });
                    console.log(window.location);

                    axios.get(process.env.REACT_APP_BASE_URL + '/employer/getEmployerByEmpId/' + this.state.employerList[rowIndex.dataIndex].empid)
                        .then(response => {
                            console.log(response);
                            if (response.data.response) {
                                if (response.data.response.acknowledgement) {
                                    window.location.replace(window.location.origin + '/manage-prospects?empid=' + this.state.employerList[rowIndex.dataIndex].empid + '&tab=prospects')
                                } else {
                                    this.setState({
                                        acknowledgement: response.data.response.acknowledgement,
                                        showAcknowledgementModal: true,
                                        sendAuthEmail: this.state.employerList[rowIndex.dataIndex].email
                                    })
                                }
                            }
                        })
                }
            },

            // onRowClick: (rowData, rowMeta) => {
            //     console.log('========== onRowClick ============');
            //     console.log(rowData);
            //     console.log(rowMeta.dataIndex);
            //     console.log(this.state.employerList[rowMeta.dataIndex].empid);
            //     if(this.state.cellFlag==false || this.state.cellFlag=='false'){
            //     this.setState({
            //         loaderShow : true
            //     });
            //     console.log(window.location);
            //     window.location.replace( window.location.origin  + '/manage-prospects?empid=' + this.state.employerList[rowMeta.dataIndex].empid)
            // }
            // }

        };

        let myDate = moment(this.state.effectiveDate).format('MM') + '/' + moment(this.state.effectiveDate).format('DD') + '/' + moment(this.state.effectiveDate).format('YYYY');
        const today = new Date();
        // Earliest selectable employer effective date is the next 1st or 15th after today.
        const tomorrow = getNextEmployerEffectiveDate(today);
        // Latest selectable effective date is 90 days from today.
        const futureDate = getEmployerEffectiveMaxDate(today);

        const minAllowedDate = new Date(today);
        minAllowedDate.setDate(minAllowedDate.getDate() + 45);
        const nextEffectiveDate = getNextEmployerEffectiveDate(minAllowedDate);
        const maxAllowedDate = new Date(nextEffectiveDate);
        maxAllowedDate.setDate(maxAllowedDate.getDate() + 45);
        
        return (

            <div>
                <Header agentId={this.state.USER_DATA.agentId} clientId={this.state.USER_DATA.clientId} associationId={this.state.USER_DATA.associationId} clientName={this.state.USER_DATA.clientName} bottomMargin={'0px'}></Header>
                {/* <div style={{ flexGrow: 1 , marginTop: 65}}>
                    <Grid container direction="row" style={{ marginBottom: '30px', testAlign: 'center', position:"fixed", zIndex:102 }}>
                        <Grid xs={12} sm={12} item={true} style={{ backgroundColor: '#41b5c2', color: '#ffffff', fontWeight: 'bold', height: '40px', fontSize: '16px', padding: '10px' }}>
                            <div style={{ cursor: 'pointer', width: '7%' }} onClick={() => window.location.replace('/')}>
                                <ArrowBackIcon /> BACK
                            </div>
                        </Grid>
                    </Grid>
                </div> */}
                <div style={{ flexGrow: 1, paddingLeft: '10px', paddingTop:82, paddingRight:60 }}>
                        {/* <Grid container direction="row">
                            <Grid xs={12} sm={12} style={{paddingBottom: "40px"}}>
                                <TopBar empID={true} data={this.state.topbarData}/>
                            </Grid>
                        </Grid> */}
                    <Grid container spacing={2} justify='center'>      
                        <Grid xs={12} sm={12} item={true} style={{}}>
                                                <TabView
                                            onTabChange={this.handleTabClick}
                                            backgroundColor={"#121212"}
                                            active={0}
                                            data={[
                                                {
                                                    label: "Dashboard ",
                                                    color: "#FFFFFF",
                                                    selectedColor: "#212121",
                                                    selectedbgColor: "#d5d6e9",
                                                    bgcolor: "#2f3192",
                                                    disable: false,
                                                    component: (
                                                        <Dashboard
                                                            householdData={
                                                                (this.state.topbarData &&
                                                                    (this.state.topbarData.employer || this.state.topbarData.emplopyer)) || {}
                                                            }
                                                            lastRefreshAt={this.state.lastRefreshAt}
                                                            loaderCommission={this.state.loaderCommission}
                                                            onRefresh={() => {
                                                                this.getTopBarData();
                                                            }}
                                                        />
                                                    ),
                                                },
                        {
                            label: "Active Employers",
                            color: "#FFFFFF",
                            selectedColor: "#212121",
                            selectedbgColor: "#d5d6e9",
                            bgcolor: "#2f3192",
                            component:
                            <div style={{ height: '100%', backgroundColor: '#ffffff' }}>
                                <div>
                                    {
                                        this.state.loaderShow ? <></> : ''
                                    }
                                    <div style={{ flexGrow: 1 }}>

                                    <EmployerSearchBar
                                        searchTypeValue={this.state.searchTypeValue}
                                        searchText={this.state.searchTextInput}
                                        targetDate={this.state.targetDate}
                                        handleChangeSearchType={(event) => this.handleChangeSearchType(event)}
                                        handleDate={(event) =>  this.handleDate(event)}
                                        // setSearch={(event) =>  this.setSearch(event)}
                                        searchRecord={(val) => this.searchRecord(val)}
                                        addEmployerModal={() => this.addEmployerModal()}
                                        refreshEmployer={() => this.refreshEmployer()}
                                        CrudButton={(props) => <CrudButton variant="contained" {...props}>{props.children}</CrudButton>}
                                        customStyle={{ formControlStyle: { width: '100%' } }}
                                        />
                                    </div>
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                    <div className="dwnloadListTable">
                                    { this.state.loaderShow ? <> <ShimmerDashboard onlyTable={true}/>  </>: 
                                        <MUIDataTable
                                              className="my-data-table"
                                            /*title={' Active Employers'}*/
                                            data={this.state.employerList}
                                            columns={this.columns}
                                            options={options}
                                        />}
                                        </div>
                                    </MuiThemeProvider>
                                </div>
                            </div>,
                        },
                        {
                                    label: "SERVICE FEE",
                                    color: "#FFFFFF",
                                    selectedColor: "#212121",
                                    selectedbgColor: "#d5d6e9",
                                    bgcolor: "#2f3192",
                                    disable:false,
                                    component: <div><Commission agentID={this.state.USER_DATA.agentId} /></div>,
                        }]
                    }/>
                       </Grid>
                        {/* <Grid xs={12} sm={4} item={true}>
                            <AccordonCommon clientId={this.state.USER_DATA.clientId} clientName={this.state.USER_DATA.clientName} agentId={this.state.USER_DATA.agentId} disable={true} forHouseholds={false} />
                        </Grid> */}
                    </Grid>
                </div>

                <Modal size={this.state.isMaximized ? null : "lg"} show={this.state.addEmployerModal} onHide={(event) => this.closeEmployerModal()} centered={!this.state.isMaximized} backdrop='static' dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}>
                    <Modal.Header style={customStyle.modal_header}>
                        <Modal.Title>{this.state.employerEdit ? "Edit Employer" : "Add Employer"}</Modal.Title>
                        <Grid item xs={2} sm={2} md={2} lg={2} style={{ backgroundColor: '#d5d6e9', display: "flex" }}>
                            <Button
                                variant="light"
                                style={{ marginLeft: 'auto' }}
                                onClick={this.toggleMaximize}
                            >
                                {this.state.isMaximized ?
                                    <FullscreenExitIcon />
                                    :
                                    <FullscreenIcon />
                                }
                            </Button>
                            <Button onClick={(event) => this.closeEmployerModal()}>
                                <CloseIcon />
                            </Button>
                        </Grid>
                    </Modal.Header>
                    <Modal.Body style={{ height: '330px', overflow: 'auto' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={2} justify="center" >
                                <Grid item xs={12} sm={10}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'CompanyName'} label={'Company Name'} value={this.state.compName} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'street'} errMsg={'Enter valid company name'} helperMsg={'Company name required'} parentDetails={{ name: 'compName' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span>Address Details</span>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'zipCode'} label={'Zip Code'} value={this.state.zipCode} disable={false} style={customStyle.textFieldWrpAgent} length={6} fieldType={'zip'} errMsg={'Enter valid zip code'} helperMsg={'Zip code required'} parentDetails={{ name: 'zipCode' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'city'} label={'City'} value={this.state.city} disable={true} style={customStyle.textFieldWrpAgent} length={5} fieldType={'city'} errMsg={'Enter valid city'} helperMsg={'City required'} parentDetails={{ name: 'city' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'state'} label={'State'} value={this.state.state} disable={true} style={customStyle.textFieldWrpAgent} length={25} fieldType={'city'} errMsg={'Enter valid state'} helperMsg={'State required'} parentDetails={{ name: 'state' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'street'} label={'Street, Suite'} value={this.state.street} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'street'} errMsg={'Enter valid street'}  parentDetails={{ name: 'street' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span>SIC</span>
                                </Grid>
                                <Grid item xs={12} sm={5} style={{ width: '90%' }}>
                                    <CommonDropDwn setChild={this.setEmpDropDownValue.bind(this)} reqFlag={false} name={'division'} label={'Division'} value={this.state.division} fieldType={'dropDwn'} disable={false} style={customStyle.dropDown} List={this.state.divisionList} errMsg={'Select valid division'}  parentDetails={{ name: 'division' }}></CommonDropDwn>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <CommonDropDwn setChild={this.setEmpDropDownValue.bind(this)} reqFlag={false} name={'industry'} label={'Industry'} value={this.state.industry} disable={this.state.industryList.length === 0} style={customStyle.textFieldWrpAgent} List={this.state.industryList} errMsg={'Select valid industry'}  parentDetails={{ name: 'industry' }}></CommonDropDwn>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <CommonDropDwn setChild={this.setEmpDropDownValue.bind(this)} reqFlag={false} name={'codeTitle'} label={'SIC Code Title'} value={this.state.codeTitle} disable={this.state.codeTitleList.length === 0} style={customStyle.textFieldWrpAgent} List={this.state.codeTitleList} errMsg={'Select valid code title'}  parentDetails={{ name: 'codeTitle' }}></CommonDropDwn>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'sicCode'} label={'SIC Code'} value={this.state.code} disable={true} style={customStyle.textFieldWrpAgent} length={10} fieldType={'num'} errMsg={'Enter valid code'}  parentDetails={{ name: 'code' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span>Employer Contact Details</span>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'fistName'} label={'First Name'} value={this.state.firstName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'firstName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'lastName'} label={'Last Name'} value={this.state.lastName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'lastName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'jobTitle'} label={'Job title'} value={this.state.jobTitle} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'text'} errMsg={'Enter valid job title'}  parentDetails={{ name: 'jobTitle' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'workEmail'} label={'Work Email'} value={this.state.workEmail} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid work email'} helperMsg={'Work email required'} parentDetails={{ name: 'workEmail' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <div>
                                        <MuiPhoneNumber
                                            name={"phone"}
                                            id="filled-required"
                                            label={"Mobile No."}
                                            data-cy="user-phone"
                                            variant="filled"
                                            defaultCountry={"us"}
                                            onlyCountries={["us"]}
                                            autoComplete='off'
                                            value={this.state.phone}
                                            length={17}
                                            onChange={(e) => this.setEmpValue(e, true, { name: 'phone' })}
                                            disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                            errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                        />
                                        {(!this.state.phone || this.state.phone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            required
                                            onBlur={() => this.setState({ birthDtFocus: true })}
                                            onMouseOver={() => this.setState({ birthDt: true })}
                                            onMouseLeave={() => this.setState({ birthDt: false })}
                                            autoComplete='off'
                                            margin="none"
                                            id="date-picker-dialog"
                                            label="Select Program Effective Date"
                                            format="MM/dd/yyyy"
                                            disabled={this.state.employerEdit && !!this.state.acknowledgement}
                                            error={this.state.dateErr} //&&!this.state.todayDateValid
                                            helperText={this.state.dateErr ? 'Enter valid date' : ''} //this.state.todayDateValid?'Date Required':
                                            value={this.state.effectiveDate} //this.state.todayDateValid?null:
                                            onFocus={e => e.target.blur()}
                                            onCopy={this.handlerCopy}
                                            onPaste={this.handlerCopy}
                                            inputProps={{ style: { fontSize: '18px', fontFamily: 'Roboto, Arial, Helvetica, sans-serif', paddingLeft: '11px', paddingRight: '10px', marginTop: '11px', '&:focus': { outline: 'none' }, color: !this.state.birthDt ? 'grey' : '#2f3192' } }}
                                            InputLabelProps={{ style: { paddingLeft: 10, paddingRight: 10, paddingTop: 12, color: !this.state.birthDtFocus ? 'grey' : this.state.birthDt ? '#2f3192' : 'grey' } }}//|| !this.state.todayDateValid
                                            onChange={this.handleDateChange.bind(this)}
                                            variant="filled"
                                            // onMouseEnter={this.handleHover}
                                            TextFieldComponent={CssTextField}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%' }}
                                            shouldDisableDate={date => !isAllowedEffectiveDate(date, minAllowedDate)}
                                            minDate={minAllowedDate}
                                            maxDate={maxAllowedDate}
                                        />
                                        <span id='bd' style={customStyle.EnrollNew2Span}></span>

                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span style={{marginRight:'20px'}}>Health Administrator Contact Details</span>
                                    <Checkbox
                                        checked={this.state.copyEmpCheck}
                                        inputProps={{
                                            'aria-label': 'secondary checkbox',
                                        }}
                                        style={{ color: '#2f3192' }}
                                        onClick={this.copyEmployerDetails}
                                    />
                                    <span>Same as above</span>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'adminFistName'} label={'First Name'} value={this.state.adminFirstName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'adminFirstName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'adminLastName'} label={'Last Name'} value={this.state.adminLastName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'adminLastName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'eeail'} label={'Email'} value={this.state.adminEmail} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email'} helperMsg={'Email required'} parentDetails={{ name: 'adminEmail' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <div>
                                        <MuiPhoneNumber
                                            name={"phoneNumber"}
                                            id="filled-required"
                                            label={"Mobile No."}
                                            data-cy="user-phone"
                                            variant="filled"
                                            defaultCountry={"us"}
                                            onlyCountries={["us"]}
                                            autoComplete='off'
                                            value={this.state.adminPhone}
                                            length={17}
                                            onChange={(e) => this.setEmpValue(e, true, { name: 'adminPhone' })}
                                            disable={false} style={customStyle.textFieldWrpAgent} fieldType={'adminPhone'}
                                            errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                        />
                                        {(!this.state.adminPhone || this.state.adminPhone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={10} style={{marginTop: 15, marginBottom: -15}}>
                                        <span style={customStyle.textBold}>Payroll Cycle</span>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <div>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="days"
                                                    name="row-radio-buttons-group"
                                                    value={this.state.payrollCycle}
                                                    onChange={(event) => this.setState({ payrollCycle: event.target.value })}
                                                >
                                                    <FormControlLabel
                                                        value="Weekly"
                                                        control={<PurpleRadio />}
                                                        label="Weekly"
                                                    />
                                                    <FormControlLabel
                                                        value="BiWeekly"
                                                        control={<PurpleRadio />}
                                                        label="Every Two Weeks"
                                                    />
                                                    <FormControlLabel
                                                        value="Monthly"
                                                        control={<PurpleRadio />}
                                                        label="Monthly"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={10} style={customStyle.sectionPart}>
                                        <span style={customStyle.textBold}>Employer Contribution</span>
                                    </Grid>
                                    <Grid item xs={12} sm={10} style={{marginTop: -15, marginBottom: -15}}>
                                        <div>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="days"
                                                    name="row-radio-buttons-group"
                                                    value={this.state.contributionType}
                                                    onChange={(event) => this.setState({ contributionType: event.target.value, employerContribution: '' })}
                                                >
                                                    <FormControlLabel
                                                        value="Doller"
                                                        control={<PurpleRadio />}
                                                        label="Fixed Amount"
                                                    />
                                                    <FormControlLabel
                                                        value="Percentage"
                                                        control={<PurpleRadio />}
                                                        label="Percentage of Monthly Contribution"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <Grid item xs={12} sm={6}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'employerContribution'} label={this.state.contributionType === 'Doller' ? 'Employer Contribution ($)' : 'Employer Contribution (%)'} value={this.state.employerContribution} disable={false} style={customStyle.textFieldWrpAgent} length={this.state.contributionType == 'Doller' ? 10 : 6} fieldType={`employerContribution${this.state.contributionType}`} errMsg={this.state.contributionType == 'Doller' ? 'Enter valid amount' : 'Enter valid percentage between 0 to 100'} helperMsg={'Employer Contribution required'} parentDetails={{ name: 'employerContribution' }}></Sample>
                                        {/* <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'employerContribution'} label={this.state.contributionType === 'Doller' ? 'Employer Contribution ($)' : 'Employer Contribution (%)'} value={this.state.employerContribution} disable={false} style={customStyle.textFieldWrpAgent} length={this.state.contributionType == 'Doller' ? 10 : 6} fieldType={`employerContribution${this.state.contributionType}`} errMsg={this.state.contributionType == 'Doller' ? 'Enter valid amount' : 'Enter valid percentage between 0 to 100'} helperMsg={'Employer Contribution required'} parentDetails={{ name: 'employerContribution' }}></Sample> */}
                                            {/* <Sample setChild={this.setEmpValue.bind(this)} name={'employerContribution'} label={`${!this.state.employerContribution ? this.state.contributionType == 'Doller' ? '$0' : '0%' : ''}`} value={this.state.employerContribution == '' ? '' : this.state.contributionType == 'Doller' ? '$'+`${this.state.employerContribution}` : `${this.state.employerContribution}%`} disable={false} style={customStyle.textFieldWrpAgent} length={60} fieldType={'employerContribution'} errMsg={'Enter valid amount'} helperMsg={'Employer Contribution required'} parentDetails={{ name: 'employerContribution' }}></Sample> */}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={10} style={customStyle.sectionPart}>
                                        <span style={customStyle.textBold}>Setup ACH</span>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Bank_Name'} label={'Bank Name'} value={this.state.bankName} disable={false} style={customStyle.textFieldWrpAgent} length={60} fieldType={'bank_name'} errMsg={'Enter valid bank name'} parentDetails={{ name: 'bankName' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Account_Name'} label={'Name on Account'} value={this.state.accountName} disable={false} style={customStyle.textFieldWrpAgent} length={120} fieldType={'accountName'} errMsg={'Enter valid account name'} parentDetails={{ name: 'accountName' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Routing_Number'} label={'Routing Number'} value={this.state.routingNo} disable={false} style={customStyle.textFieldWrpAgent} length={9} fieldType={'routingNo'} errMsg={'Enter valid routing number'} parentDetails={{ name: 'routingNo' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Account_Number'} label={'Account Number'} value={this.state.accountNumber} disable={false} style={customStyle.textFieldWrpAgent} length={26} fieldType={'accountNumber'} errMsg={'Account number must be 4 and up to 26 digits'} parentDetails={{ name: 'accountNumber' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <Grid item xs={12} sm={6}>
                                            <CommonDropDwn setChild={this.setEmpValue.bind(this)} name={"Account_Type"} account={true} label={"Account Type"} value={this.state.accountType} disable={false} style={customStyle.dropDown} fieldType={"dropDwn"} List={this.state.accountTypes} parentDetails={{ name: "accountType" }}></CommonDropDwn>
                                        </Grid>
                                    </Grid>
                            </Grid>

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <NextButton style={{ margin: '0', marginRight: '10px', width: '95px', height: '40px' }} disabled={this.state.disableSubmit} onClick={() => this.addEmployer()}>{this.state.employerEdit ? "UPDATE" : "ADD"}</NextButton>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.closeEmployerModal()}>Cancel</CustomButton>
                    </Modal.Footer>
                </Modal>

                <Modal size="sm" show={this.state.msgModal} onHide={(event) => this.setState({ msgModal: false, loaderShow: false })} centered backdrop='static'>
                    <Modal.Header style={styles.modal_header} closeButton>
                        <Modal.Title>Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <div style={customStyle.HomeContainer}>
                            <div style={customStyle.HomeMAinChild}>
                                {this.state.errMsg}
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ msgModal: false, loaderShow: false })}>Ok</CustomButton>
                    </Modal.Footer>
                </Modal>

                <Modal size={this.state.isMaximized ? null : "lg"} show={this.state.viewEmployerModal} onHide={(event) => this.setState({ isMaximized: false, viewEmployerModal: false, loaderShow: false, employerDetailsObj: [] })} centered={!this.state.isMaximized} backdrop='static' dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}>
                    <Modal.Header style={styles.modal_header}>
                        <Modal.Title>View Details</Modal.Title>
                        <Grid item xs={2} sm={2} md={2} lg={2} style={{ backgroundColor: '#d5d6e9', display: "flex" }}>
                            <Button
                                variant="light"
                                style={{ marginLeft: 'auto' }}
                                onClick={this.toggleMaximize}
                            >
                                {this.state.isMaximized ?
                                    <FullscreenExitIcon />
                                    :
                                    <FullscreenIcon />
                                }
                            </Button>
                            <Button onClick={(event) => this.setState({ isMaximized: false, viewEmployerModal: false, loaderShow: false, employerDetailsObj: [] })}>
                                <CloseIcon />
                            </Button>
                        </Grid>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px', height: '330px', overflow: 'auto' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={2} justify="center">
                                <Grid item xs={12} sm={12}>
                                    {
                                        this.state.employerDetailsObj.map((row, index, key) => (

                                            <div key={index} style={{ display: 'flex', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px' }}>
                                                <Grid item xs={4} key={index} sm={4} md={4} lg={3}>
                                                    {row.key}
                                                </Grid>
                                                <Grid item xs={7} sm={7} md={7} lg={7} key={index + 'gd'} style={{ fontWeight: 'bold' }}>
                                                    {row.value}
                                                </Grid>
                                            </div>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ isMaximized: false, viewEmployerModal: false, loaderShow: false, employerDetailsObj: [] })}>Ok</CustomButton>
                    </Modal.Footer>
                </Modal>

                <Modal size="md" show={this.state.showAcknowledgementModal} onHide={(event) => this.setState({ showAcknowledgementModal: false, loaderShow: false })} backdrop='static' centered>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <div style={customStyle.HomeContainer}>
                            <div style={customStyle.HomeMAinChild}>
                                <text>The employer hasn't acknowledged the attestations and agreements with respect to Courtesy Payroll Deductions. This is a prerequisite for employees to be added for enrollment.</text>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ showAcknowledgementModal: false })}>Close</CustomButton>
                        <CustomButton style={{ height: '40px', marginLeft: '10px' }} onClick={() => this.sendAuth()}>Send Auth</CustomButton>
                    </Modal.Footer>
                </Modal>

                <div style={{ fontSize: '11px', marginTop: '15px', fontFamily: "Roboto, Arial, Helvetica, sans-serif" }}>
                    <Footer />
                </div>
            </div>
        )
    }
}

export default Employer;